import { Box, Typography, useTheme } from "@mui/material";
import patterBackground from "../../../assets/pattern3.svg";
import { tokens } from "../../../theme";

interface Props {
  bookingType: string;
}

export default function QuickBookingHeader({ bookingType }: Props) {
    const theme = useTheme()
    const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage: `url(${patterBackground})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
        px: 4,
        py: 3,
      }}
    >
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          variant="h6"
          sx={{ color: colors.primary[100], fontWeight: 700, mb: 0.5 }}
        >
          New {bookingType} Booking
        </Typography>
      </Box>
    </Box>
  );
}
